/**
 * Shared maintenance-mode signal for the SPA (issue #2343).
 *
 * A plain reactive ref (not a Pinia store) so the Pinia-free `@/core/api`
 * barrel and `apiRequest` can set it without pulling `defineStore` into the
 * request path (see the barrel-purity note in frontend/CLAUDE.md). `App.vue`
 * reads it to render the full-screen "back soon" overlay.
 *
 * It is one-way latching: once the server reports maintenance (via the status
 * endpoint on load, or a 503 `maintenance` body on any call) we show the page
 * and leave it up. The only exit is an operator deleting the stored flag,
 * after which a reload comes up normal.
 */
import { ref } from "vue";

export const maintenanceActive = ref(false);

/** Latch the maintenance overlay on. Called from the API layer and the status poll. */
export function markMaintenanceActive(): void {
  maintenanceActive.value = true;
}

/** True when an error/response looks like the backend maintenance 503 body. */
export function isMaintenanceResponse(status: number | undefined, data: unknown): boolean {
  return (
    status === 503 &&
    typeof data === "object" &&
    data !== null &&
    (data as { maintenance?: unknown }).maintenance === true
  );
}
